<template>
  <FormModal :header="header" :name="name">
    <FormModalBody
      :is-button-loading="isProcessing"
      :footer-button-text="buttonText"
      @submit="addCard"
      test_id="new-credit-card-modal"
    >
      <StripeElements
        ref="stripeElementsRef"
        :stripe-key="stripeKey"
        v-slot="{ elements }"
      >
        <StripeElement ref="stripeCardRef" type="card" :elements="elements" />
      </StripeElements>
      <FormErrors v-if="errors.length" class="tw-mt-2" :errors="errors" />
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import { StripeElements, StripeElement } from 'vue-stripe-js'
import FormModal from './FormModal/FormModal.vue'
import FormModalBody from './FormModal/FormModalBody.vue'
import FormErrors from '../forms/FormErrors.vue'
import { computed, ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { useModals } from '@/shared/composables/useModals.js'

const emit = defineEmits(['success'])

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  stripeKey: {
    type: String,
    required: true,
  },
  isTeamCard: {
    type: Boolean,
    default: false,
  },
})

const { closeModal } = useModals()

const errors = ref([])
const isProcessing = ref(false)
const stripeElementsRef = ref(null)
const stripeCardRef = ref(null)

const header = computed(() => {
  return props.isTeamCard ? 'Change team card' : 'Add new card'
})
const buttonText = computed(() => {
  return props.isTeamCard ? 'Change' : 'Add'
})

const addCard = async () => {
  isProcessing.value = true

  try {
    const stripeResult =
      await stripeElementsRef.value.instance.createPaymentMethod({
        type: 'card',
        card: stripeCardRef.value.stripeElement,
      })
    if (stripeResult.error) throw new Error(stripeResult.error.message)

    errors.value = []

    const requestUrl = props.isTeamCard ? '/team/credit_cards' : '/credit_cards'

    router.post(
      requestUrl,
      {
        stripe_payment_method_id: stripeResult.paymentMethod.id,
      },
      {
        preserveScroll: true,
        onStart: () => {
          isProcessing.value = true
        },
        onError: (errors) => {
          if (Array.isArray(errors) || typeof errors === 'string') {
            errors.value = errors
          } else {
            errors.value = 'Something went wrong while adding your card'
          }
        },
        onSuccess: () => {
          closeModal(props.name)
          emit('success')
        },
        onFinish: () => {
          isProcessing.value = false
        },
      },
    )
  } catch (error) {
    errors.value = [
      error.message || 'Something went wrong while adding your card',
    ]
    isProcessing.value = false
  }
}
</script>
